import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES}.${BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DELIVERY_AND_SUPPORT}` as const;

export const PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES = {
  LOGISTICS: 'logistics',
  POST_PURCHASE: 'postPurchase',
  ANY_WARRANTY: 'anyWarranty',
} as const;

export interface IProductAndServicesDeliveryAndSupportForm {
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.LOGISTICS]: string;
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.POST_PURCHASE]: string;
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.ANY_WARRANTY]: string;
}

export const productAndServicesDeliveryAndSupportInitialValues: IProductAndServicesDeliveryAndSupportForm = {
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.LOGISTICS]: '',
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.POST_PURCHASE]: '',
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.ANY_WARRANTY]: '',
};
